import CPlusPlusIcon from "../assets/icons/technology_icons/c-plusplus.svg";
import CSharpIcon from "../assets/icons/technology_icons/c-sharp.svg";
import DotNetIcon from "../assets/icons/technology_icons/dotnet.svg";
import JavaIcon from "../assets/icons/technology_icons/java.svg";
import JavaScriptIcon from "../assets/icons/technology_icons/javascript.svg";
import KotlinIcon from "../assets/icons/technology_icons/kotlin.svg";
import PerlIcon from "../assets/icons/technology_icons/perl.svg";
import PythonIcon from "../assets/icons/technology_icons/python.svg";
import ReactIcon from "../assets/icons/technology_icons/react.svg";
import TypescriptIcon from "../assets/icons/technology_icons/typescript-icon.svg";
import SQLDeveloperIcon from "../assets/icons/technology_icons/sqldeveloper-original.svg";
import SpringBootIcon from "../assets/icons/technology_icons/springboot.svg";
import OpenSearchIcon from "../assets/icons/technology_icons/opensearch.svg";

export const FrontendIcons = [
    { id: 0, name: "React", image: ReactIcon },
    { id: 1, name: "TypeScript", image: TypescriptIcon },
    { id: 2, name: "JavaScript", image: JavaScriptIcon },
];

export const BackendIcons = [
    { id: 0, name: "Spring Boot", image: SpringBootIcon },
    { id: 1, name: "Java", image: JavaIcon },
    { id: 2, name: "Perl", image: PerlIcon },
    { id: 3, name: "OpenSearch", image: OpenSearchIcon },
    { id: 4, name: "SQL", image: SQLDeveloperIcon },
    { id: 5, name: ".NET", image: DotNetIcon },
];

export const OtherIcons = [
    { id: 0, name: "Python", image: PythonIcon },
    { id: 1, name: "C#", image: CSharpIcon },
    { id: 2, name: "C++", image: CPlusPlusIcon },
    { id: 3, name: "Kotlin (Android)", image: KotlinIcon },
];
